import React from "react";
import { Outlet } from "react-router-dom";
import { PortalAuthProvider } from "../../context/PortalAuthContext";
import { PortalNotificationsProvider } from "../../context/PortalNotificationsContext";
import { PortalI18nProvider } from "./PortalI18nContext";

/**
 * Parent route element for the entire `/portal/*` tree.
 * Provides a single PortalAuthProvider so that both the login page and the
 * authenticated layout share the same auth state.
 * AP-082 · Também envolve o subtree em PortalI18nProvider para suporte multilíngue
 * (Kreyòl padrão / PT-BR / EN / FR / ES).
 * AP-167 · PortalNotificationsProvider compartilha o estado do sino + página.
 */
export default function PortalRoot() {
  return (
    <PortalI18nProvider>
      <PortalAuthProvider>
        <PortalNotificationsProvider>
          <Outlet />
        </PortalNotificationsProvider>
      </PortalAuthProvider>
    </PortalI18nProvider>
  );
}
